export const ScrollBarTailwindClassesDefault = `
  [&::-webkit-scrollbar-thumb]:rounded-full
  [&::-webkit-scrollbar-thumb]:bg-[#606F6A]
  [&::-webkit-scrollbar-track]:my-5
  [&::-webkit-scrollbar-track]:rounded-full
  [&::-webkit-scrollbar-track]:bg-[#D8D8D6]
  [&::-webkit-scrollbar]:h-[5px]
  [&::-webkit-scrollbar]:w-[5px]
`

export const ScrollBarTailwindClassesPanel = `
  [&::-webkit-scrollbar-thumb]:rounded-full
  [&::-webkit-scrollbar-thumb]:bg-border
  [&::-webkit-scrollbar-track]:rounded-full
  [&::-webkit-scrollbar-track]:bg-accent
  [&::-webkit-scrollbar]:h-[3px]
  [&::-webkit-scrollbar]:w-[3px]
`

export const ScrollBarTailwindClassesEnterprise = `
  xs:[&_*::-webkit-scrollbar-thumb]:rounded-full
  xs:[&_*::-webkit-scrollbar-thumb]:bg-border
  xs:[&_*::-webkit-scrollbar-track]:rounded-full
  xs:[&_*::-webkit-scrollbar-track]:bg-accent
  xs:[&_*::-webkit-scrollbar]:h-[3px]
  xs:[&_*::-webkit-scrollbar]:w-[3px]
`
